import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import Toast, { PluginOptions, POSITION } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

// Tailwind CSS
import "./styles/tailwind.css";

import i18n from "./i18n";

const app = createApp(App);

const options: PluginOptions = {
  position: POSITION.TOP_CENTER,
};
app.use(Toast, options);

app.use(i18n).use(store).use(router).mount("#app");
